import { render, staticRenderFns } from "./TablePosiciones.vue?vue&type=template&id=2df20e33&scoped=true&"
import script from "./TablePosiciones.vue?vue&type=script&lang=js&"
export * from "./TablePosiciones.vue?vue&type=script&lang=js&"
import style0 from "./TablePosiciones.vue?vue&type=style&index=0&id=2df20e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df20e33",
  null
  
)

export default component.exports